import { Box, Grid, Image, ResponsiveContext, Text } from "grommet";
import { flatten, groupBy } from "lodash";
import * as React from "react";
import { useParams } from "react-router-dom";
import { usePermission } from "../account/AccountStore";
import { AliasCard } from "../aliases/AliasCard";
import { AliasRow } from "../aliases/AliasTable";
import { getSeason, SeasonViewModel } from "../seasons/SeasonsStore";
import { SeasonRow } from "../seasons/SeasonRow";
import { Outcome } from "../matches/OutcomeIcon";
import { StatIcon } from "../stats/StatIcon";
import { TeamName, TeamNameLogo, TeamNameLogoWrapper } from "../teams/TeamName";
import { TeamRow } from "../teams/TeamsManagement";
import { getTeam, TeamViewModel } from "../teams/TeamsStore";
import TeamHeader from "./TeamHeader";
import SkeletonWrapper from "../components/SkeletonWrapper";
import SeasonTable from "../seasons/SeasonTable";
import { getStats, StatViewModel } from "../stats/StatsStore";

const SeasonHome = () => {
    let { id } = useParams<{ id: string }>();

    const [season, setSeason] = React.useState(new SeasonViewModel());
    const [teams, setTeams] = React.useState([] as TeamViewModel[]);

    const [stats, setStats] = React.useState([] as StatViewModel[]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        getSeason(id).then((season) => {
            setSeason(season);
            console.log("interactive");
            setLoading(false);
            // setAllScoresZero(season.participants.every((participant) => participant.outcomes.every((outcome) => outcome.score == 0)));

            // Promise.all(season.participants.map((participant) => getTeam(participant.teamID))).then((teams) => setTeams(teams.map((t) => t.data.result)));
        });
        getStats().then((res) => {
            setStats(res.result);
        });
    }, [id]);

    const [allScoresZero, setAllScoresZero] = React.useState(true);

    const size = React.useContext(ResponsiveContext);

    const hasManagementPermission = usePermission("management");

    return (
        <Box align="center">
            <SkeletonWrapper loading={loading}>
                <Box width={{ max: "xxlarge", min: size }} fill gap="small">
                    <SeasonRow season={season} children={<></>} />
                    <Box pad={{ vertical: "small" }} background="background">
                        <SeasonTable season={season} statTypes={stats}></SeasonTable>
                    </Box>
                    <Grid columns={size == "small" ? ["auto"] : ["1fr", "2fr"]} gap="small">
                        <Box>{season.logoUri && <Image src={season.logoUri} style={{ maxHeight: "364px", objectFit: "contain" }} />}</Box>
                        <Box gap="small">
                            {season.participants?.map((participant, index) => (
                                <Box key={"mp." + index}>
                                    <TeamRow team={participant.team} key={index}>
                                        <Box direction="row" gap="small">
                                            {/* {participant.outcomes.map((outcome, outcomeIndex) => (
                                            <Box direction={"row"} gap="small" key={outcome.id}>
                                                {!allScoresZero && (
                                                    <Box direction={"row"} background={"background-front"} pad="small" gap="small" round="10px" align="center">
                                                        <Text>Score {outcome.score}</Text>
                                                    </Box>
                                                )}
                                                <Outcome outcome={outcome} includeText={true} disabled={false}></Outcome>
                                            </Box>
                                        ))}
                                        {participant.outcomes.length == 0 && <Text color={"background-front"}>Not yet played</Text>} */}
                                        </Box>
                                    </TeamRow>
                                    <Box background={"background"} direction="row" justify="center">
                                        {/* {season.stats.map((s) => (
                                        <Box key={"mp." + index + "." + s.statID} pad="small" justify="center" background={"background"} round="5px">
                                            <Text size="xlarge">
                                                {s.teams.filter((t) => t.teamID == participant.teamID)[0]?.value || "0"} {StatIcon(s.stat)}
                                            </Text>
                                            <Text>{s.stat.name}</Text>
                                        </Box>
                                    ))} */}
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                </Box>
            </SkeletonWrapper>
        </Box>
    );
};

export default SeasonHome;
